import { render, staticRenderFns } from "./oldtonew.vue?vue&type=template&id=d139b706&scoped=true&"
import script from "./oldtonew.vue?vue&type=script&lang=js&"
export * from "./oldtonew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d139b706",
  null
  
)

export default component.exports